import React from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ServiceLanding from "./ServiceLanding";
import catalog from "../../content/services/catalog.json";
import hy from "../../content/services/hy.json";
import ru from "../../content/services/ru.json";
import en from "../../content/services/en.json";

export default function ServiceLandingPage() {
  const { serviceSlug } = useParams();
  const { i18n } = useTranslation();
  const locale = i18n.resolvedLanguage || "hy";
  const content = { hy, ru, en }[locale] || en;
  const page = content.pages[serviceSlug];
  const item = catalog.find(service => service.slug === serviceSlug);
  if (!page || !item) return <section className="service-landing"><div className="service-shell"><h1>{content.labels.missing}</h1><a href={`/services?lang=${locale}`}>{content.labels.services}</a></div></section>;
  return <ServiceLanding page={page} labels={content.labels} locale={locale} slug={serviceSlug}
    related={item.related.map(slug => ({ title: content.pages[slug].title, href: `/services/${slug}?lang=${locale}` }))}
    links={{ services: `/services?lang=${locale}`, contact: `/get-in-touch?lang=${locale}` }} />;
}
